<template>
  <div class="main">
    <div class="pageTitle">
       <p>日常工作</p>
    </div>
    <div class="searchArea">
      <el-form
        label-position="left"
        size="small"
        label-width="80px"
        class="searchForm"
        :inline="true"
        @submit.native.prevent>
          <el-form-item label="关键字:">
              <el-input v-model="listQuery.Parameters.keyword" autocomplete="off" clearable></el-input>
            </el-form-item>
          <el-form-item>
             <el-button @click="searchTable">查询</el-button>
              <el-button @click="createNewModel">新增</el-button>
            </el-form-item>
      </el-form>
      
    </div>
    <div class="tableContainer" style="top: 120px;">
      <div class="tableContent">
            <el-table :data="dataList" border stripe >
        <el-table-column type="index" width="80" label="序号"></el-table-column>
        <el-table-column prop="name" label="名称">
          <template slot-scope="props">
            <el-button type="text" size="mini" @click="showEditDialog(props.row)">{{props.row.name}}</el-button>
            <span style="color:red" v-if="props.row.removed">（已停用）</span>
          </template>
        </el-table-column>
      </el-table>
      </div>
  
      <div class="tablePagesNumber">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.PagingInfo.currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="listQuery.PagingInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.PagingInfo.totalCount"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
       :title="dialogTitle"
      :visible.sync="taskVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="closeDialog()"
      :close-on-press-escape="false"
    >
      <div class="modalForm">
        <el-form
          :model="task"
          label-position="left"
          ref="taskForm"
          size="small"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item label="名称:" prop="name">
            <el-input v-model="task.name" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="removeTask()" class="delete_btn" type="danger" plain v-if="isEdit==true && task.removed == false">停用</el-button>
        <el-button type="success" size="small" plain @click="recoverTask()" class="delete_btn" v-if="isEdit==true && task.removed">恢复</el-button>
        <el-button size="small" @click="confirmbtn()">保存</el-button>
        <el-button size="small" @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "task",
  components: {},
  props: [],
  data() {
    return {
    
      task: {
        name: "",
        id: ""
      },
      dialogTitle:"",
      dataList: [],
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          keyword: "",
          includeRemoved:true
        }
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      taskVisible: false,
      isEdit: false
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.$taskApi.getTaskList(this.listQuery).then(res => {
        if (res.data.successful) {
          this.dataList = res.data.data.data;
          this.listQuery.PagingInfo.totalCount =
            res.data.data.pagingInfo.totalCount;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    showEditDialog(data) {
      let id = data.id;
      this.$taskApi.getTask(id).then(res => {
        this.treeData = [];
        if (res.data.successful) 
        {
          this.task = res.data.data;
          this.dialogTitle = "一般任务";
          this.isEdit = true;
          this.taskVisible = true;
        } 
        else 
        {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    searchTable() {
      this.getDataList();
    },
    createNewModel() {
      this.resetObj(this.task);
     // this.$refs["taskForm"].resetFields();
      this.isEdit = false;
      this.dialogTitle = "一般任务";
      this.taskVisible = true;
    },
    confirmbtn() {
      this.$refs["taskForm"].validate(valid => {
        if (!valid) return;
        let submitForm = JSON.parse(JSON.stringify(this.task));
        if (this.isEdit) {
          this.$taskApi.updateTask(submitForm).then(res => {
            if (res.data.successful) {
              this.getDataList();
              this.taskVisible = false;
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
        } else {
          delete submitForm.id;
          delete submitForm.createTime;
          this.$taskApi.createTask(submitForm).then(res => {
            if (res.data.successful) {
              this.getDataList();
              this.taskVisible = false;
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
        }
      });
    },
    removeTask() {
      this.$confirm("停用的日常工作在填写周报时将不再显示。但是不影响历史周报和统计数据，依然可以正常查询统计。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.task.id;
        this.$taskApi.removeTask(id).then(res => {
          if (res.data.successful) {
            this.getDataList();
            this.taskVisible = false;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    recoverTask() {
      this.$confirm("恢复日常工作将使其在填写周报时可以被选择。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.task.id;
        this.$taskApi.recoverTask(id).then(res => {
          if (res.data.successful) {
            this.getDataList();
            this.taskVisible = false;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.getDataList();
    },
    closeDialog() {
      this.resetObj(this.task);
      this.$refs["taskForm"].resetFields();
      this.isEdit = false;
      this.taskVisible = false;
    },
    resetObj(dataObj) {
      for (var i in dataObj) {
        dataObj[i] = "";
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/setting/task.vue